<template>
    <footer>
        <div>&copy; {{ getYear }} Tripwards.com</div>
        <nav class="footer-links">
            <router-link to="/privacy">Privacy</router-link>
            <router-link to="/cookies">Cookies</router-link>
            <a href="#" @click.prevent="consentStore.open()">Cookie settings</a>
            <router-link to="/contact">Contact</router-link>
        </nav>
    </footer>
</template>

<script>
import { useConsentStore } from "js/stores/consentStore.js";

export default {
    name: "PageFooter",
    data() {
        return {
            consentStore: useConsentStore(),
        };
    },
    computed: {
        getYear() {
            return new Date().getFullYear();
        },
    },
};
</script>
